import { useCallback, useState } from 'react'

import PlansService from 'src/services/plans.service'

/** Contrato del endpoint GET /api/plans/available: solo id y name. */
export interface AvailablePlan {
  id: number
  name: string
}

interface GetPlansResult {
  ok: boolean
  error?: string
}

interface UseAvailablePlans {
  plans: AvailablePlan[]
  options: ISelect[]
  loading: boolean
  getPlans: () => Promise<GetPlansResult>
}

const errorMessage = (status?: number): string => {
  if (status === 401) return 'Sesión expirada, vuelve a iniciar sesión.'
  if (status === 403) return 'No tienes permiso para consultar los planes disponibles.'
  return 'No se pudieron obtener los planes disponibles.'
}

/** Obtiene el catálogo de planes disponibles (GET /api/plans/available).
 * Reutilizable: no aplica filtros de negocio; el call-site decide qué planes mostrar. */
export const useAvailablePlans = (): UseAvailablePlans => {
  const [plans, setPlans] = useState<AvailablePlan[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getPlans = useCallback(async (): Promise<GetPlansResult> => {
    setLoading(true)
    try {
      const data: AvailablePlan[] = await PlansService.getAvailablePlans()
      setPlans(data ?? [])
      return { ok: true }
    } catch (e) {
      setPlans([])
      return { ok: false, error: errorMessage(e?.response?.status) }
    } finally {
      setLoading(false)
    }
  }, [])

  const options: ISelect[] = plans.map(plan => ({ value: plan.id, label: plan.name }))

  return { plans, options, loading, getPlans }
}
